import { injectIntl } from "react-intl";
import type { intlFormatPropTypes } from "react-intl";
import { useSelector } from "react-redux";

import { Item } from "@ps-design-system/components/ItemV2";

import { selectProfileSSOid } from "../../app-main/selectors/profile.selectors";
import { trackTodoItemClicked } from "../analytics/host-hub-analytics";
import useHostHubData from "../hooks/useHostHubData";

type HostHubBookingRequestsAndInquiriesItemProps = {
  intl: intlFormatPropTypes;
};

const HostHubBookingRequestsAndInquiriesItem = ({
  intl,
}: HostHubBookingRequestsAndInquiriesItemProps) => {
  const ssoid = useSelector(selectProfileSSOid);
  const { bookingRequestsAndInquiries } = useHostHubData();
  const {
    count: bookingRequestsAndInquiriesCount,
    countIsMonetary,
    currency,
    mediaAlt,
    mediaUrls,
    primaryCtaRoute,
  } = bookingRequestsAndInquiries.card;

  const roundedCount = Math.round(
    Number(bookingRequestsAndInquiriesCount ?? 0),
  );
  const amountDisplay = countIsMonetary
    ? intl.formatNumber(roundedCount, {
        currency: currency || "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
        style: "currency",
      })
    : intl.formatNumber(roundedCount, {
        maximumFractionDigits: 0,
        useGrouping: true,
      });

  const title = intl.formatMessage({
    defaultMessage: "Review booking requests and inquiries",
    id: "host_hub.todo_list.review_booking_requests_title",
  });
  const description = intl.formatMessage(
    {
      defaultMessage:
        "{amount} in unconfirmed requests and inquiries from the last 30 days",
      id: "host_hub.todo_list.review_booking_requests_unconfirmed_subtitle",
    },
    {
      amount: amountDisplay,
    },
  );

  return (
    <Item
      buttonOnClick={() => {
        trackTodoItemClicked({
          parameter: "review_bookings",
          ssoid,
          $_value_shown: roundedCount,
        });
        window.location.assign(primaryCtaRoute);
      }}
      description={description}
      media={mediaUrls}
      mediaAlt={mediaAlt}
      size="lg"
      title={title}
      variant="highlight"
    />
  );
};

export default injectIntl(HostHubBookingRequestsAndInquiriesItem);
